// extracted by mini-css-extract-plugin
module.exports = {"container":"CareerDescription_container__06prA","objectives":"CareerDescription_objectives__jl0S0"};